<button mat-mini-fab color="warn" (click)="onDelete(item)">
  <mat-icon>delete</mat-icon>
</button>
